import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './locales/en.json'
import usLocal from './locales/zh-CN.json'
//同时引⼊element国际化⽂件国际化组件
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZHLocale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(VueI18n)

function getBrowserLang() {
  const lang = (navigator.language || navigator.userLanguage || '').toLowerCase()
  if (lang.startsWith('zh')) return 'zh_CN'
  if (lang.startsWith('en')) return 'en'
  return 'zh_CN'
}

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh_CN: {
    ...usLocal,
    ...elementZHLocale
  }
}

const i18n = new VueI18n({
  locale: sessionStorage.getItem('lang') || getBrowserLang(),
  messages
})

export default i18n
